const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  export({ commit }, { classId, courseId, classSectionId }) {
    let url;
    if (!classSectionId) {
      url = `/api/assignment/teacher/class/${classId}/course/${courseId}/export`;
    } else {
      url = `/api/assignment/teacher/class-section/${classSectionId}/export`;
    }
    return window.axios.get(`${url}`, { responseType: 'arraybuffer' });
  },
  // eslint-disable-next-line no-unused-vars
  async fetchViewQuiz({ commit }, { submissionId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/student/${submissionId}/view-answer`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchAttemptDetail({ commit }, { assignmentId, studentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/teacher/${assignmentId}/student/${studentId}/attempt`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchStudentListAttempt({ commit }, assignmentId) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/teacher/${assignmentId}/list-submitted-quiz`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListFile({ commit }, { assignmentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/teacher/${assignmentId}/assignment-file`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchAttemptQuiz({ commit }, { assignmentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/teacher/${assignmentId}/attempt-student`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async quizStudentScoreQuiz({ commit }, { assignmentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/teacher/${assignmentId}/quiz-student-answer`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fectQuiz({ commit }, { assignmentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/quiz/student/assignment/${assignmentId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async exportCheck({ commit }, { classId, courseId, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `/api/assignment/teacher/class/${classId}/course/${courseId}/check`;
      } else {
        url = `api/assignment/teacher/class-section/${classSectionId}/check`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { classId, courseId, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `/api/assignment/teacher/class/${classId}/course/${courseId}`;
      } else {
        url = `/api/assignment/teacher/class-section/${classSectionId}`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListSearch({ commit }, { classId, courseId, search, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `/api/assignment/teacher/class/${classId}/course/${courseId}/search?classroomId=${classId}&courseId=${courseId}&keyword=${search}`;
      } else {
        url = `/api/assignment/teacher/class-section/${classSectionId}/search?classSectionId=${classSectionId}&search=${search}`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListFilter({ commit }, { classId, courseId, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `/api/assignment/teacher/class/${classId}/course/${courseId}/view-date`;
      } else {
        url = `/api/assignment/teacher/class-section/${classSectionId}/view-date`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListFilterSearch({ commit }, { classId, courseId, search, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `/api/assignment/teacher/class/${classId}/course/${courseId}/view-date/search?classroomId=${classId}&courseId=${courseId}&keyword=${search}`;
      } else {
        url = `/api/assignment/teacher/class-section/${classSectionId}/view-date/search?classSectionId=${classSectionId}&search=${search}`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async gradeBox({ commit }, { classId, courseId, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `/api/assignment/teacher/class/${classId}/course/${courseId}/grade-book`;
      } else {
        url = `/api/assignment/teacher/class-section/${classSectionId}/grade-book`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async checkAttendance({ commit }, { classId, courseId, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `/api/assignment/teacher/class/${classId}/course/${courseId}/check-attendance`;
      } else {
        url = `/api/assignment/teacher/class-section/${classSectionId}/check-attendance`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListStudent({ commit }, { classId, courseId, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `/api/assignment/student/class/${classId}/course/${courseId}`;
      } else {
        url = `/api/assignment/student/class-section/${classSectionId}`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  uploadFile({ commit }, payload) {
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    if (!payload.image) formData.delete('image');
    return window.axios.post(`/api/assignment/student/${payload.assignmentId}/upload-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  // eslint-disable-next-line no-unused-vars
  async getFile({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/student/${payload}/submission-detail`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchStudent({ commit }, assignmentId) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/teacher/${assignmentId}/assignment-student`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchStudentQuizFile({ commit }, assignmentId) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/teacher/${assignmentId}/student-convert-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListQuiz({ commit }, { classId, courseId, classSectionId }) {
    let url;
    if (!classSectionId) {
      url = `/api/assignment/teacher/class/${classId}/course/${courseId}/quiz-list`;
    } else {
      url = `/api/assignment/teacher/class-section/${classSectionId}/quiz-list`;
    }
    try {
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListQuizEdit({ commit }, { assignmentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/teacher/${assignmentId}/quiz-list-update`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  save({ rootGetters }, payload) {
    const { classId, courseId, classSectionId } = payload;
    // if (payload.assignmentTypeId === 3) {
    //   payload.dueDate = null;
    // }

    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    formData.append('schoolId', rootGetters['Auth/currentSchool']);
    formData.delete('assignmentId');

    let url;
    if (!classSectionId) {
      url = `api/assignment/teacher/class/${classId}/course/${courseId}`;
    } else {
      url = `api/assignment/teacher/class-section/${classSectionId}`;
    }

    return window.axios.post(`${url}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  update({ rootGetters }, payload) {
    const { assignmentId } = payload;
    if (payload.availableDate === null) {
      payload.availableDate = '';
    }
    if (payload.availableFrom === null) {
      payload.availableFrom = '';
    }
    if (payload.availableTime === null) {
      payload.availableTime = '';
    }
    if (payload.deadlineTime === null) {
      payload.deadlineTime = '';
    }
    if (payload.deadlineTimeStatus === null) {
      payload.deadlineTimeStatus = '';
    }
    if (payload.dueDate === null) {
      payload.dueDate = '';
    }

    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    formData.append('schoolId', rootGetters['Auth/currentSchool']);

    return window.axios.put(`api/assignment/teacher/${assignmentId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    // return window.axios.put(`api/assignment/teacher/${assignmentId}`, {
    //   ...payload,
    //   schoolId: rootGetters['Auth/currentSchool']
    // });
  },
  saveGrup({ rootGetters }, payload) {
    const { classId, courseId, classSectionId } = payload;
    let url;
    if (!classSectionId) {
      url = `api/assignment/teacher/class/${classId}/course/${courseId}/group`;
    } else {
      url = `api/assignment/teacher/class-section/${classSectionId}/group`;
    }
    return window.axios.post(`${url}`, {
      ...payload,
      schoolId: rootGetters['Auth/currentSchool']
    });
  },
  // eslint-disable-next-line no-unused-vars
  hitLambda({ rootGetters }, payload) {
    const { assignmentId } = payload;
    return window.axios.post(`api/quiz/student/assignment/${assignmentId}/hit-lambda`, {});
  },
  // eslint-disable-next-line no-unused-vars
  saveGradeBook({ rootGetters }, payload) {
    payload.gradeBook.forEach(form => (form.assignments = form.assignments.filter(data => data.submitted === true)));
    return window.axios.put(`api/assignment/teacher/save-grade-book`, {
      ...payload
    });
  },
  // eslint-disable-next-line no-unused-vars
  saveScoringQuiz({ rootGetters }, payload) {
    // console.info(payload);
    const { assignmentId } = payload;
    return window.axios.put(`api/assignment/teacher/${assignmentId}/submit-score-quiz`, {
      ...payload
    });
  },
  // eslint-disable-next-line no-unused-vars
  saveScoringFile({ rootGetters }, payload) {
    const { assignmentId } = payload;
    return window.axios.put(`api/assignment/teacher/${assignmentId}/assignment-file-score`, {
      ...payload
    });
  },
  saveGrupMove({ rootGetters }, payload) {
    const { classId, courseId, classSectionId } = payload;
    let url;
    if (!classSectionId) {
      url = `api/assignment/teacher/class/${classId}/course/${courseId}/move-group`;
    } else {
      url = `api/assignment/teacher/class-section/${classSectionId}/move-group`;
    }
    return window.axios.post(`${url}`, {
      ...payload,
      schoolId: rootGetters['Auth/currentSchool']
    });
  },
  updateGrup({ rootGetters }, payload) {
    const { id } = payload;
    return window.axios.put(`api/assignment/teacher/group/${id}`, {
      ...payload,
      schoolId: rootGetters['Auth/currentSchool']
    });
  },
  // eslint-disable-next-line no-unused-vars
  updateStudent({ rootGetters }, payload) {
    var assignmentId = payload.assignmentId;
    return window.axios.put(`api/assignment/teacher/${assignmentId}/assignment-student`, {
      ...payload
    });
  },
  // eslint-disable-next-line no-unused-vars
  updatePublish({ rootGetters }, payload) {
    const { assignmentId } = payload;
    return window.axios.put(`api/assignment/teacher/${assignmentId}/publish-assignment`, {
      ...payload
    });
  },
  // eslint-disable-next-line no-unused-vars
  convert({ rootGetters }, payload) {
    return window.axios.put(`api/assignment/teacher/${payload.assignmentId}/convert-grade`, {
      ...payload
    });
  },
  // eslint-disable-next-line no-unused-vars
  deleteGrup({ commit }, id) {
    return window.axios.delete(`/api/assignment/teacher/group/${id}`);
  },
  // eslint-disable-next-line no-unused-vars
  deleteAssignment({ commit }, id) {
    return window.axios.delete(`/api/assignment/teacher/${id}`);
  },
  // eslint-disable-next-line no-unused-vars
  deleteAttemptDetail({ commit }, { assignmentId, studentId, quizAssignmentStudentId }) {
    return window.axios.delete(`/api/assignment/teacher/${assignmentId}/student/${studentId}/attempt/${quizAssignmentStudentId}/delete-attempt`);
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/teacher/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetailStudent({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/student/${id}/assignment-detail`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchQuizTemporary({ commit }, { assignmentId, id }) {
    try {
      // const {
      //   data: { data }
      // } = await window.axios.get(`/api/quiz/student/assignment/${assignmentId}/get-answers`);

      var axios = require('axios');
      var datas = { assignmentId: assignmentId, userId: id };

      var config = {
        method: 'post',
        url: process.env.VUE_APP_BASE_LAMBDA,
        headers: {
          'Content-Type': 'application/json'
        },
        data: datas
      };

      const {
        data: { data }
      } = await axios(config);

      // console.info(datas);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  submitQuizStudent({ commit }, payload) {
    // console.info(payload.answers[0].assignmentId);
    const { assignmentId } = payload.answers[0];
    return window.axios.put(`api/quiz/student/assignment/${assignmentId}/submit`, {
      ...payload
    });
  },
  // eslint-disable-next-line no-unused-vars
  async submitQuizStudentTemporary({ commit }, payload) {
    var axios = require('axios');
    const iterator = payload.answers.keys();

    for (const key of iterator) {
      var quizId = payload.answers[key].quizTypeId;
      var quizlist = payload.answers[key];

      if (quizId === 1) {
        quizlist.quizAnswers = [quizlist.quizOther.toString()];
      } else if (quizId === 2) {
        quizlist.quizAnswers = quizlist.quizMultiple;
        if (quizlist.quizMultiple.length < 1) {
          quizlist.quizAnswers = [''];
        }
      } else if (quizId === 3 || quizId === 5) {
        quizlist.quizAnswers = [quizlist.quizOther.toString()];
      } else if (quizId === 4) {
        let dataQuiz = quizlist.quizAnswers.reduce((acc, row) => {
          acc.push(row.quizAnswer);
          return acc;
        }, []);
        quizlist.quizAnswers = dataQuiz;
      }
    }

    if (isNaN(payload.timeLeft)) {
      payload.timeLeft = 0;
    }

    var config = {
      method: 'put',
      url: process.env.VUE_APP_BASE_LAMBDA,
      headers: {
        'Content-Type': 'application/json'
      },
      data: payload
    };

    var datas = await axios(config);

    return datas;
    // return window.axios.put(`api/quiz/student/assignment/${payload.assignmentId}/save`, {
    //   ...payload
    // });
  },
  // eslint-disable-next-line no-unused-vars
  submitAttemptQuiz({ commit }, payload) {
    const { assignmentId } = payload.attempts[0];
    return window.axios.put(`api/assignment/teacher/${assignmentId}/add-attempt-student`, {
      ...payload
    });
  }
};

export default { namespaced, state, getters, mutations, actions };
